import { render } from "./MdRadio.vue?vue&type=template&id=6a81650b"
import script from "./MdRadio.vue?vue&type=script&lang=js"
export * from "./MdRadio.vue?vue&type=script&lang=js"

import "./MdRadio.vue?vue&type=style&index=0&id=6a81650b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__